/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Zoom_LabelInputs */



/**
* | output |
* | --- |
* | "Zoom +/-" |
*
* @param {Video_Filters_Zoom_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_zoom_label = /** @type {((inputs?: Video_Filters_Zoom_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Zoom_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Zoom +/-")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoom +/-")
	if (locale === "it") return /** @type {LocalizedString} */ ("Zoom +/-")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Масштабирование +/-")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acercar +/-")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩放 +/-")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズーム+/-")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम +/-")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Zoom +/-")
	return /** @type {LocalizedString} */ ("Zoom +/-")
});